import img1 from "../../assets/Images/Procurement/Procurement Suppliers.png"
import img2 from "../../assets/Images/Procurement/Procurement Suppliers Create Suppliers.png"

export default function Suppliers() {
    return (
        <section id="suppliers" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    1. Suppliers

                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Suppliers module maintains a centralized record of all vendors and
                    service providers involved in procurement activities.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        Suppliers represent external parties from whom goods or services are
                        purchased. Maintaining accurate supplier records ensures smooth
                        purchasing, payment tracking, and accountability.
                    </p>
                </section>
            </section>

            {/* SUPPLIER LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Supplier List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Suppliers module is opened, a table displays all registered
                        suppliers with essential details.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Supplier Name</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Current balance (from purchases)</li>
                        <li>Status (Active / Inactive)</li>
                        <li>Actions (Edit, Details, Delete)</li>
                    </ul>
                </div>

                <div className="bg-slate-100 rounded-lg p-4 text-sm mt-4 text-slate-500">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* SUPPLIER BALANCE LOGIC */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Supplier Balance Calculation
                </h3>

                <p className="text-slate-600 mb-4">
                    Supplier balances are calculated automatically by EventFlow and do not
                    require manual updates.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Balance increases when a new purchase is added</li>
                    <li>Balance decreases when a purchase payment is recorded</li>
                    <li>Editing or deleting payments recalculates the balance instantly</li>
                </ul>

                <p className="text-slate-600 mt-3 text-sm">
                    This ensures suppliers always reflect the correct payable amount across
                    the system.
                </p>
            </section>


            {/* ADD SUPPLIER */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Adding a New Supplier
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add New</strong> button opens the Create Supplier
                    form where a new supplier can be registered.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Name:</strong> Supplier or company name
                    </li>
                    <li>
                        <strong>Email:</strong> Optional email for communication
                    </li>
                    <li>
                        <strong>Phone:</strong> Primary contact number
                    </li>
                    <li>
                        <strong>Address:</strong> Supplier address details
                    </li>
                    <li>
                        <strong>Status:</strong> Active or Inactive
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Click <strong>Create</strong> to save the supplier or
                    <strong> Reset</strong> to clear the form.
                </p>

                <div className="bg-slate-100 rounded-lg p-4 text-sm text-slate-500 mt-4">
                    <img src={img2} alt="" />
                </div>
            </section>

            {/* EDIT SUPPLIER */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Editing a Supplier
                </h3>

                <p className="text-slate-600 mb-4">
                    The <strong>Edit</strong> action opens the same supplier form with all
                    fields pre-filled using existing data.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Update contact information</li>
                    <li>Change supplier status</li>
                    <li>Correct address or email</li>
                </ul>
            </section>

            {/* SUPPLIER DETAILS */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Viewing Supplier Details
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking <strong>Details</strong> opens a dedicated page displaying
                    complete supplier information.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Name, Email, Phone, and Address</li>
                    <li>Current supplier status</li>
                    <li>Navigation options to edit or return to list</li>
                </ul>
            </section>

            {/* DELETE SUPPLIER */}
            <section className="bg-red-50 border border-red-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2 text-red-700">
                    Deleting a Supplier
                </h3>

                <p className="text-slate-600">
                    The <strong>Delete</strong> option permanently removes a supplier from
                    the system after confirmation. Use this action carefully to maintain
                    procurement records.
                </p>
                <p className="text-slate-600 mt-2 text-sm">
                    Suppliers linked with existing purchases cannot be deleted unless related
                    records are removed.
                </p>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Supplier Management Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Well-maintained supplier records improve purchasing efficiency,
                    prevent payment disputes, and provide clarity across procurement and
                    accounting workflows.
                </p>
            </section>

        </section>
    );
}
